// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: rgb(238, 238, 238) !important;
  overflow-x: hidden !important;
}

* {
  box-sizing: border-box;
}

.ag-overlay-loading-wrapper {
  display: flex;
  padding-top: 5rem;
  justify-content: center;
  align-items: baseline;
}

a:hover {
  color: var(--wpp-primary-color-500) !important;
}

.highcharts-container {
  position: inherit !important;
}

.highcharts-tooltip {
  z-index: 9;
}

.wpp-list-item {
  width: 100%;
}
.wpp-list-item::part(item), .wpp-list-item::part(info-wrapper), .wpp-list-item::part(body-wrapper) {
  width: 100%;
}

.budget-expanded-card-configure {
  padding: 8px 8px 16px 16px;
}
.budget-expanded-card-configure::part(icon) {
  position: relative;
  bottom: 13px;
  height: 20px;
  width: 20px;
  top: 2px;
}

.budget-unexpanded-card-configure::part(icon) {
  position: relative;
  bottom: 47px;
}

.select-Otype-inline::part(message) {
  display: inline-block;
  width: 80%;
}

.selected-Otype-edit::part(message) {
  display: inline-block;
  width: 80%;
}
.selected-Otype-edit::part(action-btn) {
  display: none;
}

.configure-goal-side-modal::part(icon-cross) {
  display: none;
}

.wppTypographySegmentColor {
  color: inherit;
}

.object-attach-accordion::part(section) {
  margin: 0;
}

@keyframes fadeMessage {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
:root {
  --wpp-portal-max-width: 100%;
}

.ui.message {
  width: auto !important;
}

.wpp-sort-button::part(button) {
  height: 34px;
}

.input-currency::part(icon-end-wrapper) {
  margin: 0px;
  max-width: fit-content;
}

.dateHeaderNoDelivery {
  width: 0% !important;
}

.modalconfiguregoal {
  width: 300px;
}
.modalconfiguregoal::part(card) {
  cursor: auto;
}

.configureButton {
  width: 100%;
}

.configureButton::part(button) {
  width: 100%;
  margin-top: 16px;
}

.changegoal::part(button) {
  color: var(--wpp-grey-color-900);
  width: 265px;
  display: flex;
  justify-content: center;
}

.cardgoalheight {
  margin-bottom: 44px;
}

.ag-cell {
  display: flex;
  height: auto;
}

.ag-header-cell-text {
  font-family: "Inter";
  font-size: 14px;
  color: var(--wpp-grey-color-1000);
}

.highcharts-axis-title,
.highcharts-axis-labels,
.highcharts-xaxis-labels,
.highcharts-legend-item,
.highcharts-column-series {
  font-family: "Inter";
}

.wpp-label-container {
  display: flex;
  gap: 8px;
  flex-direction: column;
  margin-bottom: 8px;
}

.metaDataStar .star-strategy {
  margin-top: 10px !important;
}

.dataUploaderText {
  color: var(--wpp-primary-color-500);
}

.wpp-toast-container::part(item) {
  word-break: break-word;
}

.strategyWizardStepper::part(step-bg) {
  height: auto;
  min-height: 36px;
}
.strategyWizardStepper::part(step-bg):hover {
  background: none;
}
.strategyWizardStepper .description {
  min-height: 17px;
}

.hideonconfirm {
  display: none;
}

.slider-configure-step {
  --wpp-slider-width: 600px ;
}

.slider-configure-step::part(label) {
  --label-max-width: auto;
}

.wpp-table-body-row:hover .wpp-checkbox {
  visibility: visible;
}

.wpp-table-body-cell {
  border-bottom: 1px solid var(--wpp-grey-color-300);
  padding: 8px;
  position: relative;
}

.wpp-table-body-cell .wpp-checkbox {
  top: 50%;
  visibility: hidden;
}

.wpp-table-body-cell .wpp-checkbox:checked {
  visibility: visible;
}

.wpp-table-body-cell .visible-checkbox {
  visibility: visible;
}

.wpp-table__header__cell .wpp-checkbox {
  visibility: visible;
  top: inherit;
}

.budget-management-input-field::part(icon-end-wrapper) {
  max-width: 60px;
}

.stepper-sub-step-description::part(item) {
  padding: 0px;
}

.custom-codemirror-editor .CodeMirror {
  border-radius: 10px;
  height: 100%;
}

.admin-toolCode-mirror .CodeMirror {
  border-radius: 10px;
  height: 100%;
}

.custom-codemirror-empty .CodeMirror {
  border-radius: 10px;
  height: 100%;
}

.custom-codemirror-empty .CodeMirror-gutters {
  border: none;
  background-color: transparent;
}

.custom-configure-tree-btn::part(button) {
  width: 100%;
}

.confirm-wpp-table {
  border-radius: 8px;
  overflow: hidden;
}

.wpp-toggle-configure-step::part(optional-text) {
  display: none;
}

.bulkEditModal::part(content) {
  width: 600px;
}

.budgetIntDatepicker::part(datepicker-container) {
  width: 100%;
}

.activeWeightText {
  color: var(--wpp-primary-color-500);
}

.weightMetricsCard::part(card) {
  border: 1px solid var(--wpp-grey-color-500);
}

.outcomeValueTableError {
  border-bottom: none;
}
.outcomeValueTableError:hover {
  background-color: transparent !important;
}
.outcomeValueTableError td {
  border-bottom: none;
}

.budgetIntervalAccordion::part(content) {
  margin: 0;
}

.wpp-toast-container::part(item) {
  word-break: break-word;
}

.validated-input-error::part(input) {
  border: 1px solid var(--wpp-danger-color-500);
}
.validated-input-error > .wpp-icon {
  color: var(--wpp-danger-color-600);
}

.validated-error-msg::part(wrapper) {
  margin-top: 2px;
}

.edit-strategy-side-modal-slider {
  --wpp-slider-width: 696px;
}
.edit-strategy-side-modal-slider::part(label) {
  --label-max-width: auto;
  font-size: 12px;
  font-weight: 400;
  color: var(--wpp-grey-color-800);
}

.custom-wpp-input-with-label::part(input) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.wpp-internal-tooltip::part(tooltip-content) {
  word-break: keep-all;
}

.grab-formula-list-item::part(item) {
  padding: 0px;
}

.attach-object-side-model-typography::part(typography) {
  color: var(--wpp-grey-color-800);
}

.grabFormulaModal::part(back-button) {
  bottom: 6px;
}

.wpp-action-button::part(icon-start-wrapper),
.wpp-action-button::part(icon-end-wrapper) {
  margin-bottom: 2px;
}

.strategy-wizard-stepper-step::part(step-bg) {
  cursor: default;
}

.role-description::part(body) {
  width: 660px;
}

.wpp-icon-disabled {
  color: var(--wpp-icon-color-disabled);
}

.strategies-list .ag-header-cell:hover {
  background-color: unset !important;
}
.strategies-list .ag-row .wpp-checkbox {
  visibility: hidden;
}
.strategies-list .ag-row .wpp-checkbox:checked {
  visibility: visible;
}
.strategies-list .ag-row:hover .wpp-checkbox {
  visibility: visible;
}
.strategies-list .ag-row .visible-checkbox {
  visibility: visible;
}

.set-users-group::part(optional-text) {
  display: none;
}

.wppDateRangePicker::part(datepicker-container) {
  width: 98%;
}

.healthCareLinkColor {
  color: var(--wpp-primary-color-500);
}

.jobType {
  text-align: start;
  width: 800px;
}

.wpp-modal.hide, .wpp-full-screen-modal.hide {
  display: block;
}

.wpp-toggle-step::part(optional-text) {
  display: none;
}

.messagesWppTimePicker input.rc-time-picker-input {
  border: 1px solid var(--wpp-grey-color-500) !important;
  border-radius: 7px !important;
  color: var(--wpp-grey-color-1000) !important;
  font-size: 14px !important;
  font-family: var(--wpp-typography-xs-body-font-family, var(--wpp-font-family)) !important;
  height: 31px;
  width: 58% !important;
}

.rc-time-picker-panel-input-wrap {
  border: 1px solid var(--wpp-grey-color-500) !important;
  border-radius: 7px !important;
}

.rc-time-picker-panel-inner {
  border: 0px solid var(--wpp-grey-color-500) !important;
}

.rc-time-picker-panel,
.rc-time-picker-panel-input {
  font-size: 14px !important;
  font-family: var(--wpp-typography-xs-body-font-family, var(--wpp-font-family)) !important;
}

.messageWppDatpicker::part(datepicker-container) {
  width: 195px;
}

.flightRunFilter #status .ui.label {
  word-break: break-word;
}

.main-visualization::part(card) {
  background: var(--wpp-grey-color-100);
  height: 100%;
}

.wpp-side-modal-weighted-no-action::part(actions) {
  display: none;
}

.wpp-internal-tooltip::part(tooltip-content) {
  box-sizing: border-box;
}
.wpp-internal-tooltip::part(text) {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/wppGlobalStyle.scss"],"names":[],"mappings":"AAAA;EACE,+CAAA;EAEA,6BAAA;AAAF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;AADF;;AAIA;EACE,8CAAA;AADF;;AAIA;EACE,4BAAA;AADF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,WAAA;AAAF;AACE;EACE,WAAA;AACJ;;AAGA;EACE,0BAAA;AAAF;AACE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;AACJ;;AAIE;EACE,kBAAA;EACA,YAAA;AADJ;;AAME;EACE,qBAAA;EACA,UAAA;AAHJ;;AAQE;EACE,qBAAA;EACA,UAAA;AALJ;AAOE;EACE,aAAA;AALJ;;AAUE;EACE,aAAA;AAPJ;;AAWA;EACE,cAAA;AARF;;AAYE;EACE,SAAA;AATJ;;AAaA;EACE;IAAM,UAAA;EATN;EAUA;IAAI,UAAA;EAPJ;AACF;AASA;EACE,4BAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,WAAA;EACA,sBAAA;AAPF;;AAUA;EACE,oBAAA;AAPF;;AAUA;EACE,YAAA;AAPF;AASE;EACE,YAAA;AAPJ;;AAWA;EACE,WAAA;AARF;;AAWA;EACE,WAAA;EACA,gBAAA;AARF;;AAWA;EACE,gCAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,aAAA;EACA,YAAA;AARF;;AAWA;EACE,oBAAA;EACA,eAAA;EACA,iCAAA;AARF;;AAWA;;;;;EAKE,oBAAA;AARF;;AAWA;EACE,aAAA;EACA,QAAA;EACA,sBAAA;EACA,kBAAA;AARF;;AAWA;EACE,2BAAA;AARF;;AAWA;EACE,mCAAA;AARF;;AAWA;EACE,sBAAA;AARF;;AAYE;EACE,YAAA;EACA,gBAAA;AATJ;AAUI;EACE,gBAAA;AARN;AAWE;EACE,gBAAA;AATJ;;AAaA;EACE,aAAA;AAVF;;AAaA;EACE,0BAAA;AAVF;;AAaA;EACE,uBAAA;AAVF;;AAaA;EACE,mBAAA;AAVF;;AAaA;EACE,kDAAA;EACA,YAAA;EACA,kBAAA;AAVF;;AAaA;EACE,QAAA;EACA,kBAAA;AAVF;;AAaA;EACE,mBAAA;AAVF;;AAaA;EACE,mBAAA;AAVF;;AAaA;EACE,mBAAA;EACA,YAAA;AAVF;;AAaA;EACE,eAAA;AAVF;;AAaA;EACE,YAAA;AAVF;;AAaA;EACE,mBAAA;EACA,YAAA;AAVF;;AAaA;EACE,mBAAA;EACA,YAAA;AAVF;;AAaA;EACE,mBAAA;EACA,YAAA;AAVF;;AAcE;EACE,YAAA;EACA,6BAAA;AAXJ;;AAeA;EACE,WAAA;AAZF;;AAeA;EACE,kBAAA;EACA,gBAAA;AAZF;;AAeA;EACE,aAAA;AAZF;;AAeA;EACE,YAAA;AAZF;;AAeA;EACE,WAAA;AAZF;;AAeA;EACE,mCAAA;AAZF;;AAeA;EACE,2CAAA;AAZF;;AAeA;EACE,mBAAA;AAZF;AAcE;EACE,wCAAA;AAZJ;AAeE;EACE,mBAAA;AAbJ;;AAiBA;EACE,SAAA;AAdF;;AAiBA;EACE,sBAAA;AAdF;;AAkBE;EACE,6CAAA;AAfJ;AAiBE;EACE,kCAAA;AAfJ;;AAmBA;EACE,eAAA;AAhBF;;AAmBA;EACE,yBAAA;AAhBF;AAiBE;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAfJ;;AAmBA;EACE,0BAAA;EACA,6BAAA;AAhBF;;AAmBA;EACE,oBAAA;AAhBF;;AAmBA;EACE,YAAA;AAhBF;;AAmBA;EACE,gCAAA;AAhBF;;AAmBA;EACE,WAAA;AAhBF;;AAmBA;;EAEE,kBAAA;AAhBF;;AAmBA;EACE,eAAA;AAhBF;;AAmBA;EACE,YAAA;AAhBF;;AAmBA;EACE,qCAAA;AAhBF;;AAoBE;EACE,kCAAA;AAjBJ;AAqBI;EACE,kBAAA;AAnBN;AAqBM;EACE,mBAAA;AAnBR;AAwBM;EACE,mBAAA;AAtBR;AA0BI;EACE,mBAAA;AAxBN;;AA6BA;EACE,aAAA;AA1BF;;AA6BA;EACE,UAAA;AA1BF;;AA6BA;EACE,mCAAA;AA1BF;;AA6BA;EACE,iBAAA;EACA,YAAA;AA1BF;;AA8BE;EACE,cAAA;AA3BJ;;AA+BA;EACE,aAAA;AA5BF;;AA+BA;EACE,sDAAA;EACA,6BAAA;EACA,4CAAA;EACA,0BAAA;EACA,yFAAA;EACA,YAAA;EACA,qBAAA;AA5BF;;AA+BA;EACE,sDAAA;EACA,6BAAA;AA5BF;;AA+BA;EACE,sDAAA;AA5BF;;AA+BA;;EAEE,0BAAA;EACA,yFAAA;AA5BF;;AA+BA;EACE,YAAA;AA5BF;;AAiCI;EACE,sBAAA;AA9BN;;AAmCA;EACE,qCAAA;EACA,YAAA;AAhCF;;AAmCA;EACE,aAAA;AAhCF;;AAsCE;EACC,sBAAA;AAnCH;AAqCE;EACC,WAAA;AAnCH","sourcesContent":["body {\n  background-color: rgb(238, 238, 238) !important;\n  // Added this due to WppModal component. it is adding overflow: auto property. due to which horizontal scroll bar is showing up.\n  overflow-x: hidden !important;\n}\n\n// Added for WppGrid so the columns will be align\n* {\n  box-sizing: border-box;\n}\n\n.ag-overlay-loading-wrapper {\n  display: flex;\n  padding-top: 5rem;\n  justify-content: center;\n  align-items: baseline;\n}\n\na:hover {\n  color: var(--wpp-primary-color-500) !important;\n}\n\n.highcharts-container {\n  position: inherit !important;\n}\n.highcharts-tooltip {\n  z-index: 9;\n}\n\n.wpp-list-item {\n  width: 100%;\n  &::part(item), &::part(info-wrapper), &::part(body-wrapper) {\n    width: 100%;\n  }\n}\n\n.budget-expanded-card-configure {\n  padding: 8px 8px 16px 16px;\n  &::part(icon) {\n    position: relative;\n    bottom: 13px;\n    height: 20px;\n    width: 20px;\n    top: 2px;\n  }\n}\n\n.budget-unexpanded-card-configure {\n  &::part(icon) {\n    position: relative;\n    bottom: 47px;\n  }\n}\n\n.select-Otype-inline {\n  &::part(message) {\n    display: inline-block;\n    width: 80%;\n  }\n}\n\n.selected-Otype-edit {\n  &::part(message) {\n    display: inline-block;\n    width: 80%;\n  }\n  &::part(action-btn) {\n    display: none;\n  }\n}\n\n.configure-goal-side-modal {\n  &::part(icon-cross) {\n    display: none;\n  }\n}\n\n.wppTypographySegmentColor {\n  color: inherit;\n}\n\n.object-attach-accordion {\n  &::part(section) {\n    margin: 0;\n  }\n}\n\n@keyframes fadeMessage {\n  from {opacity: 1;}\n  to {opacity: 0;}\n}\n\n:root {\n  --wpp-portal-max-width: 100%;\n}\n\n.ui.message {\n  width: auto !important;\n}\n\n.wpp-sort-button::part(button) {\n  height: 34px;\n}\n\n.input-currency::part(icon-end-wrapper) {\n  margin: 0px;\n  max-width: fit-content;\n}\n\n.dateHeaderNoDelivery {\n  width: 0% !important;\n}\n\n.modalconfiguregoal {\n  width: 300px;\n\n  &::part(card) {\n    cursor: auto;\n  }\n}\n\n.configureButton {\n  width: 100%;\n}\n\n.configureButton::part(button) {\n  width: 100%;\n  margin-top: 16px;\n}\n\n.changegoal::part(button) {\n  color: var(--wpp-grey-color-900);\n  width: 265px;\n  display: flex;\n  justify-content: center;\n}\n\n.cardgoalheight {\n  margin-bottom: 44px;\n}\n\n.ag-cell {\n  display: flex;\n  height: auto;\n}\n\n.ag-header-cell-text {\n  font-family: 'Inter';\n  font-size: 14px;\n  color: var(--wpp-grey-color-1000);\n}\n\n.highcharts-axis-title, \n.highcharts-axis-labels, \n.highcharts-xaxis-labels,\n.highcharts-legend-item,\n.highcharts-column-series {\n  font-family: 'Inter';\n}\n\n.wpp-label-container {\n  display: flex;\n  gap: 8px;\n  flex-direction: column;\n  margin-bottom: 8px;\n}\n\n.metaDataStar .star-strategy {\n  margin-top: 10px !important;\n}\n\n.dataUploaderText {\n  color: var(--wpp-primary-color-500);\n}\n\n.wpp-toast-container::part(item) {\n  word-break: break-word;\n}\n\n.strategyWizardStepper {\n  &::part(step-bg) {\n    height: auto;\n    min-height: 36px;\n    &:hover {\n      background: none;\n    }\n  }\n  .description {\n    min-height: 17px;\n  }\n}\n\n.hideonconfirm {\n  display: none;\n}\n\n.slider-configure-step {\n  --wpp-slider-width: 600px\n}\n\n.slider-configure-step::part(label){\n  --label-max-width: auto;\n}\n\n.wpp-table-body-row:hover .wpp-checkbox {\n  visibility: visible;\n}\n\n.wpp-table-body-cell {\n  border-bottom: 1px solid var(--wpp-grey-color-300);\n  padding: 8px;\n  position: relative;\n}\n\n.wpp-table-body-cell .wpp-checkbox {\n  top: 50%;\n  visibility: hidden;\n}\n\n.wpp-table-body-cell .wpp-checkbox:checked {\n  visibility: visible;\n}\n\n.wpp-table-body-cell .visible-checkbox {\n  visibility: visible;\n}\n\n.wpp-table__header__cell .wpp-checkbox {\n  visibility: visible;\n  top: inherit;\n}\n\n.budget-management-input-field::part(icon-end-wrapper) {\n  max-width: 60px;\n}\n\n.stepper-sub-step-description::part(item) {\n  padding: 0px;\n}\n\n.custom-codemirror-editor .CodeMirror{\n  border-radius: 10px;\n  height: 100%\n}\n\n.admin-toolCode-mirror .CodeMirror{\n  border-radius: 10px;\n  height: 100%\n}\n\n.custom-codemirror-empty .CodeMirror{\n  border-radius: 10px;\n  height: 100%\n}\n\n.custom-codemirror-empty {\n  .CodeMirror-gutters {\n    border: none;\n    background-color: transparent;\n  }\n}\n\n.custom-configure-tree-btn::part(button) {\n  width: 100%;\n}\n\n.confirm-wpp-table {\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.wpp-toggle-configure-step::part(optional-text) {\n  display: none;\n}\n\n.bulkEditModal::part(content) {\n  width: 600px,\n}\n\n.budgetIntDatepicker::part(datepicker-container) {\n  width: 100%;\n}\n\n.activeWeightText {\n  color: var(--wpp-primary-color-500);\n}\n\n.weightMetricsCard::part(card) {\n  border: 1px solid var(--wpp-grey-color-500);\n}\n\n.outcomeValueTableError {\n  border-bottom: none;\n\n  &:hover {\n    background-color: transparent !important;\n  }\n\n  td {\n    border-bottom: none;\n  }\n}\n\n.budgetIntervalAccordion::part(content){\n  margin: 0;\n}\n\n.wpp-toast-container::part(item) {\n  word-break: break-word;\n}\n\n.validated-input-error {\n  &::part(input) {\n    border: 1px solid var(--wpp-danger-color-500);\n  }\n  & > .wpp-icon {\n    color: var(--wpp-danger-color-600);\n  }\n}\n\n.validated-error-msg::part(wrapper) {\n  margin-top: 2px;\n}\n\n.edit-strategy-side-modal-slider {\n  --wpp-slider-width: 696px;\n  &::part(label) {\n    --label-max-width: auto;\n    font-size: 12px;\n    font-weight: 400;\n    color: var(--wpp-grey-color-800);\n  }\n}\n\n.custom-wpp-input-with-label::part(input) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.wpp-internal-tooltip::part(tooltip-content) {\n  word-break: keep-all;\n}\n\n.grab-formula-list-item::part(item) {\n  padding: 0px;\n}\n\n.attach-object-side-model-typography::part(typography) {\n  color: var(--wpp-grey-color-800);\n}\n\n.grabFormulaModal::part(back-button) {\n  bottom: 6px;\n}\n\n.wpp-action-button::part(icon-start-wrapper),\n.wpp-action-button::part(icon-end-wrapper) {\n  margin-bottom: 2px;\n}\n\n.strategy-wizard-stepper-step::part(step-bg) {\n  cursor: default;\n}\n\n.role-description::part(body) {\n  width: 660px;\n}\n\n.wpp-icon-disabled {\n  color: var(--wpp-icon-color-disabled);\n}\n\n.strategies-list {\n  .ag-header-cell:hover {\n    background-color: unset !important;\n  }\n\n  .ag-row {\n    .wpp-checkbox {\n      visibility: hidden;\n\n      &:checked {\n        visibility: visible;\n      }\n    }\n\n    &:hover {\n      .wpp-checkbox {\n        visibility: visible;\n      }\n    }\n\n    .visible-checkbox {\n      visibility: visible;\n    }\n  }\n}\n\n.set-users-group::part(optional-text) {\n  display: none;\n}\n\n.wppDateRangePicker::part(datepicker-container) {\n  width: 98%;\n}\n\n.healthCareLinkColor {\n  color: var(--wpp-primary-color-500);\n}\n\n.jobType {\n  text-align: start;\n  width: 800px;\n}\n\n.wpp-modal, .wpp-full-screen-modal {\n  &.hide {\n    display: block;\n  }\n}\n\n.wpp-toggle-step::part(optional-text) {\n  display: none;\n}\n\n.messagesWppTimePicker input.rc-time-picker-input {\n  border: 1px solid var(--wpp-grey-color-500) !important;\n  border-radius: 7px !important;\n  color: var(--wpp-grey-color-1000) !important;\n  font-size: 14px !important;\n  font-family: var(--wpp-typography-xs-body-font-family, var(--wpp-font-family)) !important;\n  height: 31px;\n  width: 58% !important;\n};\n\n.rc-time-picker-panel-input-wrap {\n  border: 1px solid var(--wpp-grey-color-500) !important;\n  border-radius: 7px !important;\n};\n\n.rc-time-picker-panel-inner {\n  border: 0px solid var(--wpp-grey-color-500) !important;\n}\n\n.rc-time-picker-panel,\n.rc-time-picker-panel-input {\n  font-size: 14px !important;\n  font-family: var(--wpp-typography-xs-body-font-family, var(--wpp-font-family)) !important;\n}\n\n.messageWppDatpicker::part(datepicker-container) {\n  width: 195px;\n}\n\n.flightRunFilter {\n  #status {\n    .ui.label {\n      word-break: break-word;\n    }\n  }\n}\n\n.main-visualization::part(card) {\n  background: var(--wpp-grey-color-100);\n  height: 100%;\n}\n\n.wpp-side-modal-weighted-no-action::part(actions) {\n  display: none;\n}\n\n// to be removed after next version upgrade.\n// hack for tooltip text style issue.\n.wpp-internal-tooltip {\n  &::part(tooltip-content) {\n   box-sizing: border-box;\n}\n  &::part(text) {\n   width: 100%;\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
